var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterieurVoitureRecuperationCollegue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.78 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-56,.cls-58,.cls-63{fill:none;}.cls-2{fill:#20456e;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_82);}.cls-4{fill:#f4f4f4;}.cls-37,.cls-4,.cls-5,.cls-8{opacity:0.32;}.cls-5{fill:#727272;}.cls-6{fill:#eaba8b;}.cls-7{fill:#d8d8d8;}.cls-16,.cls-8{fill:#7392c9;}.cls-9{fill:#828282;}.cls-10{fill:#3f3f3f;}.cls-11{fill:#e2e2e2;}.cls-12{fill:#b7b7b7;}.cls-13{fill:#afafaf;}.cls-14{fill:#ccc;}.cls-15{fill:#c19167;}.cls-17{fill:#c9c9c9;}.cls-18{fill:#a3a3a3;}.cls-19{fill:#5b5b5b;}.cls-20{fill:#353535;}.cls-21{clip-path:url(#clip-path);}.cls-22{fill:#aab4b5;}.cls-23{fill:#f5f7f7;}.cls-24{clip-path:url(#clip-path-2);}.cls-25{clip-path:url(#clip-path-3);}.cls-26{fill:#173856;}.cls-27{fill:#97675e;}.cls-28{clip-path:url(#clip-path-4);}.cls-29{fill:#fbbcaa;}.cls-30{clip-path:url(#clip-path-5);}.cls-31{fill:#fff;}.cls-32{fill:#82cec4;}.cls-33{fill:#442114;}.cls-34{fill:#232728;}.cls-35{fill:#b8b8b8;}.cls-36{fill:#686d6d;}.cls-37{fill:#bddff2;}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_95);}.cls-39{clip-path:url(#clip-path-6);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_109);}.cls-41{fill:#4e5254;}.cls-42{clip-path:url(#clip-path-7);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_96);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_36);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_36-2);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_80);}.cls-48{fill:#c7ced3;stroke-width:10px;}.cls-48,.cls-56,.cls-58{stroke:#272b2e;}.cls-48,.cls-56,.cls-57,.cls-58,.cls-61,.cls-63{stroke-miterlimit:10;}.cls-49{clip-path:url(#clip-path-8);}.cls-50,.cls-57{fill:#272b2e;}.cls-51{fill:#303335;}.cls-52{fill:#55595b;}.cls-53{fill:#cc5a52;}.cls-54{fill:#414649;}.cls-55{fill:#434749;}.cls-56{stroke-width:6px;}.cls-57{stroke:#0f1011;}.cls-57,.cls-58,.cls-63{stroke-width:2px;}.cls-59{clip-path:url(#clip-path-9);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_84);}.cls-61{stroke:#232728;fill:url(#D\xE9grad\xE9_sans_nom_84-2);}.cls-62{fill:#57595b;}.cls-63{stroke:#4e5254;}.cls-64{fill:#282b2e;}.cls-65{fill:url(#D\xE9grad\xE9_sans_nom_31);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_82",
    x1: 347.41,
    y1: 1423.97,
    x2: 2714,
    y2: 1423.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2250.18,1851.21s-1.76,50.54-4,58.58c0,0,33.19,43.46,43.65,60.88a58.94,58.94,0,0,0,43.65,28.72c17.23,2.3,55.13-2.3,58.58-16.08s5.74-28.72-13.78-46-54.95-39.9-55.14-45.95-9.19-40.2-9.19-40.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2317.35,1814.45l112.57,6.89s0-36.76-12.64-40.2c0,0-45.53-7.93-50.54-13.79-6.89-8-17.23-12.63-25.27-34.46s-26.42,0-26.42,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2193.29,1191.87s4.59,121.76,13.78,170,18.38,189.53,20.68,210.21,8,111.42,4.59,143.58,12.64,136.7,12.64,136.7,41.35,35.61,74.66,6.89c0-57.43-3.44-109.13,0-116,0,0,23-3.44,31-16.08,0-19.53-6.9-83.85,0-114.87,0,0,10.33-59.73,13.78-91.89,13.79-31,62-251.56,54-313.59C2361,1186.12,2193.29,1191.87,2193.29,1191.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2272.55,766.85c-.17-11.57-1.15-43.65-1.15-43.65s-8-6.89-10.34-13.78-2.3-16.08-2.3-16.08-12.63-5.75-17.23-23,3.45-21.82,6.89-20.67,9.56,3.07,9.56,3.07-4.37-34.49.78-49,16.08-28.72,59.73-29.86,50.55,33.31,50.55,42.5v30.43a13.56,13.56,0,0,1,10.33.58c5.75,2.58,5.75,14.93,3.45,23s-3.45,21.83-12.64,19.53c-1.14,12.64-1.14,13.79-3.44,20.68s-9.19,17.57-9.19,17.57v38.71L2338,787.53l-40.22-2.59S2272.71,778.42,2272.55,766.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2183,949l18.9,163-13.78,75.82s72.37,42.5,157.37,37.9,81.55-14.93,81.55-14.93l-12.63-113.72,33.31,89.6s34.46,5.74,68.92-16.08c0,0-51.69-176.9-54-218.25s-8.94-116.59-8.94-116.59S2449.93,812,2422.36,796a234.38,234.38,0,0,0-55.08-22.87s5.93-6.78,2.54-14.41c-1.08-2.45.85-8.47-11.86-11,0,5.93-.84,15.25-4.23,19.48-5.94,5.09-17.8,11.87-31.35,17.8-18.31.45-38.76-12-47.45-17.8-1.7-2.54-2.55-8.47-2.85-20.43-3.86.89-6.72,2-8.17,3.49-5.08,5.08-7.63,14.4-5.08,18.64-34.74,6.78-69.48,26.27-69.48,26.27s-34.08,13.1-39.83,40.67-47.5,158.55-54.44,193.55C2088,1065,2083.41,1182,2087,1174c1.22-2.7,19,17,51,6C2144,1109,2183,949,2183,949Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_95",
    x1: 2204.99,
    y1: 1887.68,
    x2: 2204.99,
    y2: 1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_109",
    x1: 1502,
    y1: 2194.09,
    x2: 1502,
    y2: 1691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#292d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#32353a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3f4249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,41-71,77-89,16-9,117-33,234-33s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_96",
    x1: 1530.71,
    y1: 1703.94,
    x2: 1530.71,
    y2: 1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72757d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    x1: 1506.19,
    y1: 1641.44,
    x2: 1506.19,
    y2: 1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5e69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36",
    x1: 2139,
    y1: 3000,
    x2: 2139,
    y2: 2501.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d4146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#484b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36-2",
    x1: 585.7,
    x2: 585.7,
    y2: 2550.51,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_80",
    x1: 1500,
    y1: 357,
    x2: 1500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2128,1748s20-44,19-73h152s-5,63-22,73Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_84",
    x1: 2213.5,
    y1: 1748,
    x2: 2213.5,
    y2: 1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3e4248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4f58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_84-2",
    x1: 2219.26,
    y1: 1717.25,
    x2: 2219.26,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 416.8,
    y1: 1560.32,
    x2: 416.8,
    y2: 1039.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97675e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#90635b",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#624a47",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#413839",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2e2e30",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282b2e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "int\xE9rieur voiture r\xE9cup\xE9ration coll\xE8gue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.78,
    width: 3000,
    height: 3000
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_12",
    "data-name": "Calque 12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1518.78 614 1518.78 178 2333.78 223 2302.78 1248 2249.78 1248 2265.78 614 1518.78 614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1518.78 957 1518.78 813 1999.78 813 2010.78 1282 1518.78 1276.35 1518.78 957"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2443.25 236.23 2351.2 1385.42 3001.78 1483 3001.78 307 2443.25 236.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1986.78 1296 1985.78 813 2265.78 614 2247.78 1300 1986.78 1296"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1518.78,
    y: 909,
    width: 373,
    height: 413
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1518.78 813 1985.78 813 2265.78 614 1518.78 614 1518.78 813"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1518.78 919 1668.78 919 1668.78 991 1518.78 991 1518.78 1005.15 1668.78 1005.15 1668.78 1214 1679.78 1214 1679.78 1006 1772.78 1006 1772.78 992 1680.78 992 1680.78 919 1862.78 919 1862.78 992 1802.78 992 1802.78 1006 1862.78 1006 1862.78 1214 1880.78 1214 1880.78 909 1518.78 909 1518.78 919"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1877.78 642 1891.78 614 1960.78 614 1960.78 1310 1877.78 1310 1877.78 642"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1766.78 812.71 1773.53 794 1806.78 794 1806.78 1259 1766.78 1259 1766.78 812.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2125.78 1288 2129.78 833 2244.78 767 2244.78 794 2163.78 840 2159.78 1288 2125.78 1288"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1891.78 614 1877.78 642 1877.78 1298 1891.78 1298 1891.78 614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "2514.09 132.01 2470.91 1384.8 2283.51 1387.5 2307.84 262.4 2514.09 132.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2441.89 973.62 2437.41 827.69 2507.6 800.52 2770.48 792.45 2611.62 962.41 2441.89 973.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2373.2 984.73 2377.82 809.51 2492.5 758.41 2977.06 743.09 2977.58 760.08 2926.04 775.67 2506.42 794.56 2429.41 827.93 2428.17 983.05 2373.2 984.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2386.28 824.26 2429.41 827.93 2428.17 983.05 2383.32 984.42 2386.28 824.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "2386.28 824.26 2432.76 827.83 2506.42 794.56 2793.78 782 2805.78 766 2491.89 775.99 2386.28 824.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2504.64,794.56l-77,33.37-1.24,155.12,41.8-7.29L2605,972l16-17-78.34,2.47L2546,805.29l130.94-4L2680,904l12-13-3.08-90.1,83.08-1.38L2792,782Zm-7.53,167.31-26.32.8-27.87,4.86L2447,839.35l50.55-24.19Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "2472.75 975.67 2472.56 962.67 2444.7 967.53 2448.77 839.35 2499.04 814.79 2498.55 961.88 2518.54 961.26 2519.75 805.15 2773.78 800 2793.78 782 2506.42 794.56 2429.41 827.93 2428.17 983.05 2472.75 975.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1518.78 614 1518.78 178 703.78 223 734.78 1248 787.78 1248 771.78 614 1518.78 614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1518.78 957 1518.78 813 1037.78 813 1026.78 1282 1518.78 1276.35 1518.78 957"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "594.3 236.23 686.36 1385.42 1.78 1488 1.78 291 594.3 236.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1050.78 1296 1051.78 813 771.78 614 789.78 1300 1050.78 1296"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1145.78,
    y: 909,
    width: 373,
    height: 413
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1518.78 813 1051.78 813 771.78 614 1518.78 614 1518.78 813"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1518.78 919 1368.78 919 1368.78 991 1518.78 991 1518.78 1005.15 1368.78 1005.15 1368.78 1214 1357.78 1214 1357.78 1006 1264.78 1006 1264.78 992 1356.78 992 1356.78 919 1174.78 919 1174.78 992 1234.78 992 1234.78 1006 1174.78 1006 1174.78 1214 1156.78 1214 1156.78 909 1518.78 909 1518.78 919"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1159.78 642 1145.78 614 1076.78 614 1076.78 1310 1159.78 1310 1159.78 642"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1270.78 812.71 1264.03 794 1230.78 794 1230.78 1259 1270.78 1259 1270.78 812.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "911.78 1288 907.78 833 792.78 767 792.78 794 873.78 840 877.78 1288 911.78 1288"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1145.78 614 1159.78 642 1159.78 1298 1145.78 1298 1145.78 614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "523.47 132.01 566.64 1384.8 754.04 1387.5 729.71 262.4 523.47 132.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "595.67 973.62 600.15 827.69 529.95 800.52 267.08 792.45 425.93 962.41 595.67 973.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "664.36 984.73 659.74 809.51 545.05 758.41 60.49 743.09 59.97 760.08 111.52 775.67 531.13 794.56 608.15 827.93 609.39 983.05 664.36 984.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "651.28 824.26 608.15 827.93 609.39 983.05 654.24 984.42 651.28 824.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "651.28 824.26 604.79 827.83 531.13 794.56 243.78 782 231.78 766 545.66 775.99 651.28 824.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M242,782l20,17.52,83.08,1.38L342,891l12,13,3.07-102.73,130.94,4,3.33,152.18L413,955l16,17,136.81,3.76,41.8,7.29-1.24-155.12-77-33.37Zm294.46,33.16L587,839.35l4.07,128.18-27.87-4.86-26.32-.8Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "564.81 975.67 564.99 962.67 592.86 967.53 588.79 839.35 538.52 814.79 539 961.88 519.01 961.26 517.8 805.15 263.78 800 243.78 782 531.13 794.56 608.15 827.93 609.39 983.05 564.81 975.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2250.18,1853.51s-1.76,50.54-4,58.58c0,0,33.19,43.45,43.65,60.88a58.94,58.94,0,0,0,43.65,28.72c17.23,2.29,55.13-2.3,58.58-16.09s5.74-28.71-13.78-45.94-54.95-39.9-55.14-46-9.19-40.2-9.19-40.2Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2297.82,1994.79s0-41.35,27.57-54c-39.06-35.61-40.21-39.06-41.36-50.55s-3.44-42.5-3.44-42.5h21.82s-1.15,29.87,3.45,40.21,47.09,45.94,47.09,45.94,35.61-5.74,47.1,26.42v41.36l-59.73,20.67Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2317.35,1814.45l112.57,6.89s0-36.76-12.64-40.2c0,0-45.53-7.93-50.54-13.79-6.89-8-17.23-12.63-25.27-34.46s-26.42,0-26.42,0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2398.9,1827.09s0-24.13,4.6-33.32c-21.83-4.59-41.36-13.78-48.25-18.37s-20.67-42.51-20.67-42.51l23-9.19,28.72,27.57L2443.7,1780l23,55.14-26.42,35.61Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2193.29,1191.87s4.59,121.76,13.78,170,18.38,189.53,20.68,210.21,8,111.42,4.59,143.58,12.64,136.7,12.64,136.7,41.35,35.61,74.66,6.89c0-57.43-3.44-109.13,0-116,0,0,23-3.44,31-16.08,0-19.53-6.9-83.85,0-114.87,0,0,10.33-59.73,13.78-91.89,13.79-31,62-251.56,54-313.59C2361,1186.12,2193.29,1191.87,2193.29,1191.87Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2194.44,1190.72s4.59,121.76,13.78,170,18.38,189.53,20.68,210.21,8,111.42,4.59,143.59,12.64,136.69,12.64,136.69,41.35,35.61,74.66,6.89c0-57.43-3.44-109.12,0-116,0,0,23-3.44,31-16.08,0-19.53-6.9-83.85,0-114.87,0,0,10.33-59.73,13.78-91.89,13.78-31,62-251.56,54-313.59C2362.14,1185,2194.44,1190.72,2194.44,1190.72Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2220.86,1559.44s16.08,25.27,60.88,20.68,49.39-31,49.39-31l8-229.74h16.08l-6.89,189.53s9.19,6.89,16.08,4.6c0,17.23-11.49,88.44-11.49,88.44s-11.48,9.19-24.12,5.75c-3.44,33.31-3.44,46-3.44,46s-36.34,49.43-95.34,8C2217.41,1622.62,2220.86,1559.44,2220.86,1559.44Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2305.86,1218.29s-26.42,23-60.88,21.82-38-47.71-38-47.71Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2381.67,1220.58s14.93,24.12,28.72,24.12,18.38-18.37,18.38-18.37-12.64-37.91-14.94-34.46S2381.67,1220.58,2381.67,1220.58Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2319.83,1743.26,2331.45,1540l7.87-221.28s20.34-53.38,21.18-70.33,0-23.6,0-23.6l76.26-15.38-64.39,533.82-38.13,18.64Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2510.32,1168.89s20.68,49.4,21.83,57.44,11.49,67.77,8,74.66-10.34,0-10.34,0-1.15,8-6.89,9.19-9.19-8-9.19-8-9.19,4.59-13.78-3.45c-5.75,2.3-13.79-3.44-13.79-6.89s-10.34-47.1-10.34-47.1-3.44-5.74-4.59-10.33l-13.79-55.14Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2272.55,766.85l-1.15-43.65s-8-6.89-10.34-13.78-2.3-16.08-2.3-16.08-12.63-5.75-17.23-23,3.45-21.82,6.89-20.67,9.56,3.07,9.56,3.07-4.37-34.49.78-49,16.08-28.72,59.73-29.86,50.55,33.31,50.55,42.5v30.43a13.56,13.56,0,0,1,10.33.58c5.75,2.58,5.75,14.93,3.45,23s-3.45,21.83-12.64,19.53c-1.14,12.64-1.14,13.79-3.44,20.68s-9.19,17.57-9.19,17.57v38.71L2338,787.53l-49.39-3.45Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2132.66,1172.53s7.53,36.68,9.48,43.18,6,10.08,1.2,15.23-36.23,19.46-46.34,12.72-11.56-4.37-16.11-9.89-12.27-30.34-8.93-33.72,9.67-4,9.67-4-.39-10.12,7-16.25l6.09-5,1-4.3S2118.72,1166.64,2132.66,1172.53Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2272.55,766.85s39,47.1,57.43,98.79c13.78-43.65,27.57-98.79,27.57-98.79a55.16,55.16,0,0,1-39.06,18.38C2288.63,786.38,2272.55,766.85,2272.55,766.85Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2188.12,1038.52,2201.9,1112l-13.78,75.82s72.37,42.5,157.37,37.9,81.55-14.93,81.55-14.93l-12.63-113.72,33.31,89.6s34.46,5.74,68.92-16.08c0,0-51.69-176.9-54-218.25S2454,836.15,2454,836.15s-4-23.92-31.59-40-37.91-21.83-37.91-21.83,1.15-11.49,16.08-18.38-34.46-27.57-48.24-28.72-95.34-2.29-122.91,19.53c-10.34,11.49,18,9.21,22.58,19.55-36.76,0-63.93,24.1-63.93,24.1s-33.31,23-39.06,50.54-56.28,152.78-54,188.39,44.79,47.09,48.24,39.05S2188.12,1038.52,2188.12,1038.52Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2413.89,1096.75s-4.55-139.12,0-147.43,8.47-26.27,11.86-63.55c0,0,22-62.17,13.55-76.26s30.51,31.35,30.51,31.35,63.55,344.86,61,344.86-96.6,5.08-96.6,5.08Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M2165,1199l18-250,20.75-55.6s4.69-71.21-35.36-85.6-91.74,259.3-91.74,259.3L2076,1213Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2258.83,768.84s36.43,34.74,43.21,39c0,0,8.47-21.19,19.49-22.88,3-.47-44.06-14.41-46.6-17.8s-2.55-22-2.55-22l-21.18,4.24v17.79Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2184.26,1176.4s78.8,37.28,150.82,37.28c40.68,0,95.75-13.56,95.75-13.56v13.56l-65.24,28.81-190.65-42.37Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2321.53,784.94s16.94,2.54,21.18,16.94c16.1-11,24.57-28.8,24.57-28.8l19.49-15.26L2341.86,735l15.74,12.33s1.21,13.93-3.87,19.86S2321.53,784.94,2321.53,784.94Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2258,653s2,8,2,11,6-16,5-22c5-5,9-17,7-24,14,6,50,16,67,5-2-9-11-17-11-17s18-2,23,8,5,23,11,24c0,9,5,17,5,17l2-8,5-33s-7-24-33-40-75,11-80,15c0,0-8,11-8,18S2256,645,2258,653Z",
    transform: "translate(1.78)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M0,2721l382-778,85-518,2154,109s15,487,27,491,352,265,352,265v710H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "522.78 1271 468.78 1296 463.78 1204 1.78 680 1.78 441 652.78 1226 2393.78 1235 3001.78 466 3001.78 731 2600.78 1295 2471.78 1267 522.78 1271"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1024,1223.12l229-.12,524-31.73S2163,1223,2216,1223s157.13,1.62,176,12c20,11,23,23,59,29s81,9,105,13,65,30,65,30l-1544,44Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2663,1318l337,82v908s-316-169-325-250S2663,1318,2663,1318Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M365,1322,0,1446-1,2570.32S389,2024,398,1943,365,1322,365,1322Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2556,1979s-3-661,23-753,135-206,135-206l286-289V890s-314,307-318,377c-2.37,41.47-25,456-7,751,2.67,43.74,295,231,325,272v141s-229-178-286-221S2579,2098,2556,1979Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M493,1923s0-640-26-732S315,983,315,983L0,680-.17,856S260,1063,347,1226c16.34,92.25,17,518,0,717-5.34,62.48-347,545-347,615v206s309.72-488.11,347-549C407,2117,470,2042,493,1923Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M0,449s602,718,651,750,87,60,164,57,1577-22,1577-22l607.89-760.09L3000,329S2117,222,1579,222,372,217,0,325l-.15,2.8C-3.9,400.26,0,449,0,449Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M0,1720s341-152,365-216,69-155,66-213c-19-80-18-92-27-112s-13-35-29-57C350.8,1088.72,0,751,0,751Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3000,1565s-235-93-250-103-75.66-57.26-94-79c-27-32-31-143,0-186,10.53-14.6,90-109,90-109l254-244Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1779,1887.68s537-4.68,577-16.68,275-299,275-299l-830,32Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1205,1691s17,199,22,224,10,109,62,179,93,102,220,100,151-26,209-96,81-399,81-399Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1205,1667s19,122,80,158,390.74,19.67,424,12c78-18,101-191,101-191Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,41-71,77-89,16-9,117-33,234-33s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M401,1541s-42-22-50-79-7-114,50-153,79-30,140-41,191-53,295-55,222,2,302,48c15,10,36,11,59,5,36-15,23-57,59-75,16-9,135-47,252-47s237,22,250,28,21,22,26,33,14,33,18,41,4,15,12,17,766,23,795,33,47,22,57,33,48,55,48,96c0,18.44-3,52-8,63s-13,20-17,32-19,23-23,27-47,51-76,56-531-8-602,15-114,76-189,81-557,8-583,0-21-16-26-32-6-43-25-64Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1169,1478V1364a73.52,73.52,0,0,1-2-48c8-26,22-40,35-45,7-13,13.25-15.56,18.12-26.78S1241,1169,1244,1169s256-41,256-41l277,38,19.42,67.7s5.78,20.14,12.68,26.72S1831,1278,1835,1289s18,69,12,113-10,112-10,112-2,21-10,34-16.18,20.75-19,23c-5,4-16,10-25,13-7,11-67.65,43.93-77,48-23,10-138,8-169,9s-190,0-190,0-19,2-49-13-96-54-96-54-25-17-30-40-4-43-3-48A16.94,16.94,0,0,0,1169,1478Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1278,3000s0-150,25-235,94-173,197-212,335-56,491,0c0-81,508-44,586-36s202,33,251,71,151,230,172,350v62Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1147,3000s28-128,24-214-1-131-81-157-111-39-147-58-457.21-39.64-616.11,12.68S0,3000,0,3000Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M0,357S500,226,1500,237,3000,355,3000,355V0H0Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1248.78,
    y: 1296,
    width: 512,
    height: 233
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1091.5,1426.5c-5-10-99-211-328-200-226.62,10.89-338,219-338,219s-71,99-59,254c8.17,105.49,70,201,165,245s276,70,443-77S1145.5,1530.5,1091.5,1426.5ZM763.05,1296.36c192-9.14,270.86,158,275,166.3,10.22,19.52,15.74,44.48,17,72.41-12.92,7.08-30.94,15.91-43.07,17.93-18,3-55-22-55-22s-76-49-165-56-162,25-175,30-82,39-110,37-33-13-39-30c-1.92-5.43.76-14.63,5.29-24.64,3.86-5.83,6.33-8.91,6.33-8.91S573,1305.41,763.05,1296.36Zm-332,399.32c3.62-19,17-29.57,21.91-31.68,7-3,67-25,88,47s83,89,96,103c20.39,22,14,72,6,83-3.18,4.38-8.58,8.59-13.93,12.09a273.53,273.53,0,0,1-45.57-15.59C535.48,1872.09,447.64,1793.26,431.09,1695.68ZM933,1828c-55.81,44.08-110.1,69.08-160.27,80.93-10.32-20.33-40-107,23.27-135.93,81-37,111-91,120-103s66-37,98-33c14.74,1.84,3,51,10,59.66C1003,1748,972,1795.64,933,1828Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M454,1522s-14.38,22.84-11.19,50.42S458,1604,467,1608s62-2,83,32,44,116,137,114,182-87,203-131c39-34,48-11,75-11s90-17.93,90-36v-44l-358-69Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M475,1500s-24,7-21,22,10,29,29,31,36,6,94-21,109-42,146-43,150,9,200,45,75,40,87,38,45-31,45-31l-.64-10.78L1002,1503l-302-70Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M431,1433l23-68,162.76-114.54L795,1207l198,54,113,158,16,64s-30-49-50-74-57.75-98.67-135-133c-45-20-124-47-209-35s-164,63-208,102C486.13,1373,459,1406,431,1433Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M432.5,1690.08S428,1694,428,1708s35,110.09,73,142,94,67,120,67c15-13,20-23,20-23Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M773,1900s0,17,3,19,71-22,101-38,94-71,110-92,50-70,49-94-6-54-12-55-22,0-22,0Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1279,1248h449s-6-43-41-57-323-17-357,0S1279,1248,1279,1248Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "1318.78 1784 1321.78 1748 1386.78 1748 1386.78 1784 1318.78 1784"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 1686.28,
    cy: 1774.5,
    rx: 22.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 1686.28,
    cy: 1765.5,
    rx: 22.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1707,1765.5c0,8.56-10.07,15.5-22.5,15.5s-22.5-6.94-22.5-15.5c0-4.28,11.75,4.5,23,4.5S1707,1761.22,1707,1765.5Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1510.78 1748 1627.78 1748 1634.78 1784 1510.78 1784 1510.78 1748"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1510.78,
    y: 1784,
    width: 124,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "1510.78 1779 1633.78 1779 1634.78 1784 1510.78 1784 1510.78 1779"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1319.78,
    y: 1744,
    width: 308,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1319.78 1748 1315.78 1789 1318.78 1787 1318.78 1784 1321.78 1748 1319.78 1748"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "1315.78 1789 1318.78 1787 1634.78 1788 1634.78 1784 1627.78 1748 1627.78 1744 1638.78 1790 1315.78 1789"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1319.78,
    y: 1744,
    width: 308,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1247,1701.57s22,95.43,73,103.43,363,17,393,0,46-101,46-101",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 1362.63,
    cy: 1572.09,
    rx: 22.5,
    ry: 23.18,
    transform: "translate(-20.81 19.86) rotate(-0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1385.13,1571.77c.18,12.8-9.74,23.32-22.17,23.5s-22.64-10-22.83-22.85c-.09-6.4,11.85,6.56,23.1,6.39S1385,1565.37,1385.13,1571.77Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 1655.63,
    cy: 1571.09,
    rx: 22.5,
    ry: 23.18,
    transform: "translate(-20.76 24.1) rotate(-0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1678.13,1570.77c.18,12.8-9.74,23.32-22.17,23.5s-22.64-10-22.83-22.85c-.09-6.4,11.85,6.56,23.1,6.39S1678,1564.37,1678.13,1570.77Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1403.78,
    y: 1594,
    width: 224,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1403.78,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1441.11,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1478.44,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1515.78,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1553.11,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1590.44,
    y: 1594,
    width: 37.33,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1972.78,
    y: 1351,
    width: 619,
    height: 178,
    rx: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 2060.17,
    y1: 1440,
    x2: 2506.47,
    y2: 1440
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M2128,1748s20-44,19-73h152s-5,63-22,73Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2278,1751s-4-8-6-21,9-77,9-77l25,20-17,80Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M2139.53,1717.25c2.58,0,152.74,0,152.74,0s3.23-12.75,6.73-42.25H2147S2148,1693,2139.53,1717.25Z",
    transform: "translate(1.78)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "2279.28 1748.5 2129.78 1748 2130.28 1746.5 2280.78 1747 2279.28 1748.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1212,1764.57s24.88,95.43,82.55,103.43,410.5,17,444.43,0,52-101,52-101",
    transform: "translate(1.78)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "personnages"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M144.75,1819.81s13.47-312.08-6.73-381.68-39.3-259.33-55-344.64c0-134.72,95.87-302,206.56-346.89,130.22-52.76,290.75-40.41,368.21,26.94S780.15,933,782.39,985.72s19,479.19,1,519.6-32.55,43.78-65.11,47.15-155.92,17-155.92,17L550,1819.81Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1025.3,1488.1s-64.14-28.87-64.14-54.52,14.8-55.73,14.8-55.73,22.88,32.07,44,21.52c19.25-9.63-25-95.37-25-95.37s1.43-30.78,25-34,119.74,54.52,123,85.52,5.55,79.11,5.55,79.11l-48.32,48.11Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1055,3000l36-384s-20.78-243.42-98-271c-84-30-344,0-344,0l262,655Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M775,1831.27s224.5-128.29,233.06-170S1015,1517,1015,1517s-8-76,49-91c41-10.78,91.59.09,101.21,26.82s111.18,243.75,87.66,375.24S885,2276,885,2276Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,1710c68.12-10.09,145.87-19.29,145.87-19.29s-13.47,46,30.31,66.24,317.7,33.67,354.75,19.08,20.2-30.31,20.2-30.31S777.27,1794.49,823,1844c109,118,71.77,308.72,79,369,9,75,9,787,9,787H0S-1,1793,0,1710Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M83,1730c18,40.42,174,101,287.38,89.81s233.51-15.71,253.71-38.17,25.07-21.16,25.07-21.16-29.56-79.87-67.73-91.1-108.89,20.21-227.88,35.93c-26.81,3.54-233.51,7.85-204.46-68.38C129,1651.42,65.05,1689.59,83,1730Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M83,1093.49s-32.56-11.23-40.42-53.89,0-52.76,20.21-64c-15.72-25.82-12.35-35.92-1.12-44.9C50.45,922.85,28,874.58,76.27,851c0-21.33,16.84-32.55,31.44-23.57C101,783.65,122.3,759,159.34,759c-6.73-20.21,18-53.89,49.4-56.13,0-24.7,29-71.29,72.31-56.41,14.13-42.38,65.77-43.5,89.34-34.52,0-22.45,59.5-55,88.69-29.19C472.55,567,527.56,546.78,564.61,604c41.53-22.45,87.56-25.82,104.4,32.56,0,0,59.5-12.35,60.62,50.51,33.68-3.37,52.76,70.73,28.06,80.83,48.28,21.33,34.8,62.87,25.82,78.58,34.8,14.6,33.68,62.87,19.09,83.08C826.17,961,777.9,988,777.9,988s-1.12,44.91-46,84.2c0,0-74.09,26.94-143.69,11.22C546.26,1073.92,163.84,1206.87,83,1093.49Z",
    transform: "translate(1.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M83,1093.49C80.5,1090.84,118,1354,132,1415c14,40,15.13,96.47,15.36,106.76,41.17-.56,284.78,75.78,336.42,15.16,32.55-75.22,124.61-117.88,119-197.58s12.35-171.76,78.59-170.64c21.33,14.59,21.33,57.25,21.33,57.25s0,24.7,24.69,0c0-42.66-12.35-88.6,12.35-111.13s0-75.11,0-75.11Z",
    transform: "translate(1.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterieurVoitureRecuperationCollegue);
export default __webpack_public_path__ + "static/media/interieur_voiture_recuperation_collegue.c1c4d4cfbbccf16fd7e8745294ebf816.svg";
export { ForwardRef as ReactComponent };